module.exports = __webpack_public_path__ + "71c792136762397e97eba52ace057d92.pdf";